const VISIBILITIES = {
  EDIT_DIALOG: {
    OPEN: "ACTION.LOCAL.VISIBILITIES.EDIT_DIALOG.OPEN",
    CLOSE: "ACTION.LOCAL.VISIBILITIES.EDIT_DIALOG.OPEN",
  },
  TOGGLE: "ACTION.LOCAL.VISIBILITIES.TOGGLE",
};

export default VISIBILITIES;
